import EDate from './EDate';
import { pad00 } from './string';

import { LocalTimeZone } from '../../../utils/LocalTimeZone';

export class YMD {
  public readonly year: number;
  public readonly month: number;
  public readonly day: number;

  public constructor(date: Date | string, from: null | 'UTC' | 'Local' | string) {
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      /* Take date in format YYYY-MM-DD and convert to YMD day month year */

      const [year, month, day] = date.split('-').map(Number);
      this.day = day;
      this.month = month - 1;
      this.year = year;
      return;
    }

    const edate = new EDate(
      date,
      !from || from === 'UTC' ? 'UTC' : from === 'Local' ? LocalTimeZone.name : from
    );

    this.day = edate.getDate();
    this.month = edate.getMonth();
    this.year = edate.getFullYear();
  }

  public toYMDBackendDate(): Date {
    return new Date(`${this.year}-${pad00(this.month + 1)}-${pad00(this.day)}T12:00:00.000Z`);
  }

  public toDate(h = 12, m = 0, s = 0, ms = 0): Date {
    return new Date(this.year, this.month, this.day, h, m, s, ms);
  }

  public toEDate(tz: string, h = 12, m = 0, s = 0, ms = 0): EDate {
    return new EDate(
      {
        day: this.day,
        month: this.month,
        year: this.year,
        hour: h,
        min: m,
        sec: s,
        ms: ms,
      },
      tz
    );
  }

  public toString(): string {
    return this.toEDate(LocalTimeZone.name).format('PP');
  }

  public format(format: string): string {
    return this.toEDate(LocalTimeZone.name).format(format);
  }

  public valueOf(): number {
    return this.toEDate('UTC').getTime();
  }

  /* Compare this YMD to another YMD */
  public compare(other: YMD): number {
    return this.valueOf() - other.valueOf();
  }

  /* >= operator for two YMDs */
  public ge(other: YMD): boolean {
    return this.compare(other) >= 0;
  }

  /* <= operator for two YMDs */
  public le(other: YMD): boolean {
    return this.compare(other) <= 0;
  }

  /* < operator for two YMDs */
  public lt(other: YMD): boolean {
    return this.compare(other) < 0;
  }

  /* > operator for two YMDs */
  public gt(other: YMD): boolean {
    return this.compare(other) > 0;
  }
}

export const mostRecentDate = (a: YMD, b: YMD): YMD => {
  if (a.toDate().getTime() >= b.toDate().getTime()) return a;
  return b;
};
